import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { AuthService } from '@auth0/auth0-angular';
import { OrganisationService, OrgAppAccess, ToolAppKey } from 'src/app/organisation.service';
import { NgbCollapse, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';


@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbCollapse, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, AsyncPipe]
})
export class NavBarComponent implements OnInit {
  isCollapsed = true;
  taeUser: any;
  inContextOrg: any;
  inContextEntityName: string;
  currentApp: ToolAppKey | null = null;
  appAccess: OrgAppAccess;

  constructor(
    public auth: AuthService,
    private api: ApiService,
    private orgService: OrganisationService,
    @Inject(DOCUMENT) private doc: Document
  ) { }

  ngOnInit() {

    this.appAccess = this.orgService.getDefaultAppAccess();

    this.auth.user$.subscribe({
      next: (profile) => {

        this.api.getUsersId$(profile.sub).subscribe({
          next: (user) => {
            this.taeUser = user;
          }
        });

      }
    });

    this.orgService.currentOrg$.subscribe((org) => {

      this.appAccess = this.orgService.getOrgAppAccess(org);

      if (org.name && org.name != "") {
        this.inContextOrg = org;
        this.inContextEntityName = org.name;
      }
      else {
        this.inContextOrg = null;
        this.auth.user$.subscribe((profile) => {
          this.inContextEntityName = profile.name;
        });
      }
    });

    this.orgService.currentApp$.subscribe((app) => {
      this.currentApp = app;
    });
  }

  isInMotorTwinContext(): boolean {
    return this.currentApp === 'motortwin';
  }

  isInFmedaContext(): boolean {
    return this.currentApp === 'fmeda';
  }

  setAppContext(app: ToolAppKey) {
    this.orgService.setActiveApp(app);
  }

  loginWithRedirect() {
    this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({
      logoutParams: {
        returnTo: this.doc.location.origin
      }
    });
  }
}
